import { render, staticRenderFns } from "./FamilyPatentsLoading.vue?vue&type=template&id=b8f58d3c"
import script from "./FamilyPatentsLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyPatentsLoading.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports